import { render, staticRenderFns } from "./UploadedDocuments.vue?vue&type=template&id=df7963c4&scoped=true&lang=pug"
import script from "./UploadedDocuments.vue?vue&type=script&lang=js"
export * from "./UploadedDocuments.vue?vue&type=script&lang=js"
import style0 from "./UploadedDocuments.vue?vue&type=style&index=0&id=df7963c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7963c4",
  null
  
)

export default component.exports